// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2NR0e","right":"Footer_right__1cmnk","buttons":"Footer_buttons__1ry5-"};